module.exports = __webpack_public_path__ + "static/img/pcmt_xiamo_zt.73c5660.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pcmt_xiamo_zt.jpg
// module id = 7Le0
// module chunks = 1